/**
 * Generates a `@supports` CSS rule for checking if a specific property and value are supported.
 *
 * @param property - A string representing the CSS property to check support for (e.g., `"display"`).
 * @param value - A string representing the CSS value to check support for (e.g., `"grid"`).
 * @returns A string representing the `@supports` rule.
 *
 * ### Example
 * ```typescript
 * import { supports } from './supports';
 *
 * const rule = supports('display', 'grid');
 * console.log(rule); // "@supports (display: grid)"
 * ```
 */
const supports = (property, value) => `@supports (${property}: ${value})`;
/**
 * Generates a `@supports not` CSS rule for checking if a specific property and value are **not** supported.
 *
 * @param property - A string representing the CSS property to check lack of support for (e.g., `"display"`).
 * @param value - A string representing the CSS value to check lack of support for (e.g., `"grid"`).
 * @returns A string representing the `@supports not` rule.
 *
 * ### Example
 * ```typescript
 * import { supportsNot } from './supports';
 *
 * const rule = supportsNot('display', 'grid');
 * console.log(rule); // "@supports not (display: grid)"
 * ```
 */
const supportsNot = (property, value) => `@supports not (${property}: ${value})`;

export { supports, supportsNot };
